import React from 'react'
import { Container, Title } from './styles'
import { withDashboardLoader } from '~/components/shared'
import { DiagnosesList } from '~/components/diagnoses/DiagnosesList'
import { capitalize } from '~/utils'
import { usePatient } from '~/context'
import { message } from '~/services'
import { useDocumentTitle, useFetchDiagnoses } from '~/hooks'

const DiagnosesPage = (): JSX.Element => {
  useDocumentTitle(message('titles.diagnoses'))
  const { getVisiblePatientId } = usePatient()
  const patientId = getVisiblePatientId()

  const diagnosesFetchParams = patientId ? { patientId } : null
  const { data, isLoading, error } = useFetchDiagnoses(diagnosesFetchParams)
  const diagnoses = data ?? []
  const errorMessage = error?.message ?? ''

  return (
    <Container>
      <Title>{capitalize(message('diagnoses.diagnoses'))}</Title>
      <DiagnosesList diagnoses={diagnoses} isLoading={isLoading} error={errorMessage} />
    </Container>
  )
}

export const Diagnoses = withDashboardLoader(DiagnosesPage)
